/** Site cards that have lapsed or are about to, for the "Coming up" list. Site
 *  cards are workspace-admin only on the server, so a 403 is the normal answer
 *  for everyone else and any failure just means no rows. Drawn at once from the
 *  background read cache, which the app warms before Home opens. */

import { useEffect, useMemo, useState } from 'react';
import type { ExpiringWorkerCard } from '../../types/workerCards';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { expiringSiteCardsRead, localDayKey } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly ExpiringWorkerCard[] = [];

export function useExpiringSiteCards(workspaceId: string | undefined): readonly ExpiringWorkerCard[] {
  // A dashboard left open overnight refetches when the date changes, so a card
  // entering the window appears without a reload.
  const [dayKey, setDayKey] = useState(localDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(localDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? expiringSiteCardsRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
